module.exports = __webpack_public_path__ + "img/aspida.d3d74e3e.png";